<template>
    <div class="toolbox-header">
        <button class="btn-icon icon-close" @click="closeToolbox"></button>
        <button class="btn-icon btn-edit icon-edit" @click="stepBack" v-show="getItemStep === 2"></button>
        <h2>Objekt hinzufügen</h2>
        <div class="subheader" v-show="getItemStep === 2">
            <div class="entry" v-show="getLayerName">
                <div class="label">In Layer</div>
                <div class="desc">{{ getLayerName }}</div>
            </div>
            <div class="entry" v-show="getSelectedObjectsText">
                <div class="label">Verknüpft</div>
                <div class="desc">{{ getSelectedObjectsText }}</div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      closeToolbox () {
        this.$emit('close')
      },
      stepBack () {
        this.item.step = 1
      }
    },
    computed: {
      getLayerName () {
        if (!this.item.loaded) {
          return false
        }
        if (typeof this.item.getLayer !== 'function') {
          return false
        }

        return this.item.getLayer() ? this.item.getLayer().title : false
      },
      getSelectedObjectsText () {
        let count = this.item.selectedObjects.length
        if (!count) {
          return false
        }
        return count > 1 ? count + ' Objekte' : count + ' Objekt'
      },
      getItemStep () {
        return this.item.step
      }
    }
  }
</script>

<style scoped>

</style>
